'use strict';

var cubicBezier = require('./cubic-bezier.cjs');
var mirror = require('./modifiers/mirror.cjs');
var reverse = require('./modifiers/reverse.cjs');

const backOut = /*@__PURE__*/ cubicBezier.cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/ reverse.reverseEasing(backOut);
const backInOut = /*@__PURE__*/ mirror.mirrorEasing(backIn);

exports.backIn = backIn;
exports.backInOut = backInOut;
exports.backOut = backOut;
//# sourceMappingURL=back.cjs.map
